import { MarketSelectorTableHeaderConfig } from 'src/components/MarketSelector/MarketSelectorTable/types';

export const PERP_MARKETS_COLUMN_HEADERS_CONFIG: MarketSelectorTableHeaderConfig[] =
	[
		{
			label: 'Market',
			value: 'market',
			breakpoint: 'all',
			showForMarketTypes: 'all',
		},
		{
			label: 'Price',
			value: 'price',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'all',
		},
		{
			label: '24h %',
			value: 'priceChangePct',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'all',
		},
		{
			label: 'Price | 24h',
			value: 'priceChangePct',
			breakpoint: 'mobile-only',
			showForMarketTypes: 'all',
		},
		{
			label: '24h Vol',
			value: 'volume',
			breakpoint: 'all',
			showForMarketTypes: 'all',
		},
		{
			label: 'Open Interest',
			value: 'openInterest',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'perp-only',
		},
		{
			label: 'Funding',
			value: 'funding',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'perp-only',
		},
		{
			label: '24h Low',
			value: 'priceLow24h',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'spot-only',
		},
		{
			label: '24h High',
			value: 'priceHigh24h',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'spot-only',
		},
	];

export const SPOT_MARKETS_COLUMN_HEADERS_CONFIG: MarketSelectorTableHeaderConfig[] =
	[
		{
			label: 'Market',
			value: 'market',
			breakpoint: 'all',
			showForMarketTypes: 'all',
		},
		{
			label: 'Price',
			value: 'price',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'all',
		},
		{
			label: '24h %',
			value: 'priceChangePct',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'all',
		},
		{
			label: 'Price | 24h',
			value: 'priceChangePct',
			breakpoint: 'mobile-only',
			showForMarketTypes: 'all',
		},
		{
			label: '24h Vol',
			value: 'volume',
			breakpoint: 'all',
			showForMarketTypes: 'all',
		},
		{
			label: '24h Low',
			value: 'priceLow24h',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'spot-only',
		},
		{
			label: '24h High',
			value: 'priceHigh24h',
			breakpoint: 'desktop-only',
			showForMarketTypes: 'spot-only',
		},
	];
